import { ele } from "cables-shared-client";
import web from "./index.js";
import api from "./api.js";

export default class Browser
{
    constructor()
    {
        this._logResult = {};
        this._Browser = {};
        this._Browser.browserCounter = 0;

        this._tests = [
            () =>
            {
                this._logResult.browser = platformLib.name;
                this._logResult.browser_version = platformLib.version;
            },
            () =>
            {
                let str = "";
                if (platformLib.os)
                {
                    if (platformLib.os.family)
                    {
                        str += platformLib.os.family + " ";
                        this._logResult.os_family = platformLib.os.family;
                    }
                    if (platformLib.os.version)
                    {
                        str += platformLib.os.version + " ";
                        this._logResult.os_version = platformLib.os.version;
                    }
                    if (platformLib.os.architecture)
                    {
                        str += platformLib.os.architecture + "bit ";
                        this._logResult.os_architecture = platformLib.os.architecture;
                    }
                    if (platformLib.product)
                    {
                        str += "(" + platformLib.product + ")";
                        this._logResult.product = platformLib.product;
                    }
                }

                this._logResult.language = navigator.language || navigator.userLanguage;
            },

            () =>
            {
                const result = {};
                let canvas;
                let gl;
                let exts;

                try
                {
                    canvas = document.createElement("canvas");
                    // gl = canvas.getContext('webgl2')  || canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

                    let glVersion = 0;

                    gl = canvas.getContext("webgl2", canvas);
                    if (gl)
                    {
                        glVersion = 2;
                    }
                    else
                    {
                        gl = canvas.getContext("webgl", canvas) || canvas.getContext("experimental-webgl", canvas);
                        glVersion = 1;
                    }

                    // window.testgl=gl;

                    if (gl)
                    {
                        let html = "";

                        this._logResult.webgl_versionNum = glVersion;
                        exts = gl.getSupportedExtensions();

                        const webglVersion = gl.getParameter(gl.VERSION);
                        this._logResult.webgl_version = webglVersion;

                        const glslVersion = gl.getParameter(gl.SHADING_LANGUAGE_VERSION);
                        this._logResult.webgl_glsl_version = glslVersion;

                        const dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
                        if (dbgRenderInfo)
                        {
                            const webGlRenderer = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
                            this._logResult.webgl_renderer = webGlRenderer;

                            this._logResult.webgl_gpu_info = this.getGPU(webGlRenderer);
                            const webGlVendor = gl.getParameter(dbgRenderInfo.UNMASKED_VENDOR_WEBGL);
                            this._logResult.webgl_vendor = webGlVendor;
                        }

                        if (gl.isContextLost())
                        {
                            this._logResult.webgl_renderer = "BROKEN WEBGL: CONTEXT LOST";
                        }

                        canvas = document.createElement("canvas");
                        const glcaveat = canvas.getContext("webgl", { "failIfMajorPerformanceCaveat": true }) || canvas.getContext("experimental-webgl", { "failIfMajorPerformanceCaveat": true });
                        this._logResult.webgl_majorPerformanceCaveat = !glcaveat;

                        this._logResult.webgl_params = {};

                        if (gl.MAX_SAMPLES !== undefined) this._logResult.webgl_params.MAX_SAMPLES = gl.getParameter(gl.MAX_SAMPLES);
                        this._logResult.webgl_params.MAX_FRAGMENT_UNIFORM_VECTORS = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
                        this._logResult.webgl_params.MAX_VERTEX_UNIFORM_VECTORS = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
                        this._logResult.webgl_params.MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                        this._logResult.webgl_params.DEPTH_BITS = gl.getParameter(gl.DEPTH_BITS);

                        this._logResult.webgl_params.MAX_VARYING_VECTORS = gl.getParameter(gl.MAX_VARYING_VECTORS);
                        this._logResult.webgl_params.MAX_VERTEX_ATTRIBS = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
                        this._logResult.webgl_params.MAX_COMBINED_TEXTURE_IMAGE_UNITS = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
                        this._logResult.webgl_params.MAX_VERTEX_TEXTURE_IMAGE_UNITS = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
                        this._logResult.webgl_params.MAX_RENDERBUFFER_SIZE = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);

                        const dbgWEBGL_draw_buffers = gl.getExtension("WEBGL_draw_buffers");
                        if (dbgWEBGL_draw_buffers)
                        {
                            this._logResult.webgl_params.MAX_DRAW_BUFFERS = gl.getParameter(dbgWEBGL_draw_buffers.MAX_DRAW_BUFFERS_WEBGL);
                        }
                        else
                        {
                            if (gl.MAX_DRAW_BUFFERS !== undefined)
                            {
                                this._logResult.webgl_params.MAX_DRAW_BUFFERS = gl.getParameter(gl.MAX_DRAW_BUFFERS);
                            }
                        }

                        const extAniso = gl.getExtension("EXT_texture_filter_anisotropic");
                        if (extAniso)
                        {
                            const max = gl.getParameter(extAniso.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                            this._logResult.webgl_params.MAX_TEXTURE_MAX_ANISOTROPY_EXT = max;
                        }

                        if (!exts || exts.length === 0)
                        {
                        }
                        else
                        {
                            this._logResult.webgl_extensions = exts;

                            for (let i = 0; i < exts.length; i++)
                                html += "&nbsp;&nbsp;&nbsp;- " + exts[i] + "<br/>";
                        }
                    }
                    else
                    {
                        this._logResult.webgl_versionNum = 0;
                    }
                }
                catch (e)
                {
                    console.log("webgl getcontext", e);
                    return;
                }

                canvas = undefined;
            },

            async () =>
            {
                let hasWebGpu = navigator.gpu != undefined;

                if (navigator.gpu)
                {
                    let adapter = null;
                    let device = null;
                    try
                    {
                        adapter = await navigator.gpu.requestAdapter();
                        device = await adapter.requestDevice();
                    }
                    catch (e)
                    {
                        adapter = null;
                        hasWebGpu = false;
                        return;
                    }

                    this._logResult.api_webGpu = hasWebGpu;

                    hasWebGpu = !!adapter;
                    if (hasWebGpu)
                    {

                        this._logResult.webgpu_adapter_vendor = adapter.info.vendor;
                        this._logResult.webgpu_adapter_architecture = adapter.info.architecture;
                        this._logResult.webgpu_adapter_device = adapter.info.device || "unknown";
                    }

                    const limits = [];
                    for (let i in device.limits) limits.push({ "title": i, "value": device.limits[i] });
                    this._logResult.webgpu_limits = limits;

                    const features = [];
                    const valueIterator = adapter.features.values();
                    for (const value of valueIterator)
                        features.push(value);
                    this._logResult.webgpu_features = features;

                    this._logResult.api_webGpu = hasWebGpu;
                }
            },

            () =>
            {
                let hasWebCodecs = window.VideoEncoder != undefined;
                this._logResult.api_webCodecs = hasWebCodecs;
            },

            () =>
            {
                this._logResult.display_pixel_ratio = window.devicePixelRatio;
                if (window.devicePixelRatio)
                {
                    this._logResult.display_pixel_ratio_float = window.devicePixelRatio.toPrecision(2);
                }
                this._logResult.window_size_width = window.innerWidth;
                this._logResult.window_size_height = window.innerHeight;

                this._logResult.window_size_pixel_width = window.innerWidth * window.devicePixelRatio;
                this._logResult.window_size_pixel_height = window.innerHeight * window.devicePixelRatio;

                this._logResult.screen_size_width = window.screen.availWidth;
                this._logResult.screen_size_height = window.screen.availHeight;

                this._logResult.screen_dynamic_range_standard = window.matchMedia("(dynamic-range: standard)").matches;
                this._logResult.screen_dynamic_range_high = window.matchMedia("(dynamic-range: high)").matches;
                this._logResult.screen_dynamic_range_high_string = window.matchMedia("(dynamic-range: high)").matches ? "true" : "false";
                this._logResult.screen_colorDepth = window.screen.colorDepth;

                this._logResult.screen_gamut_srgb = window.matchMedia("(color-gamut: srgb)").matches;
                this._logResult.screen_gamut_p3 = window.matchMedia("(color-gamut: p3)").matches;
                this._logResult.screen_gamut_rec2020 = window.matchMedia("(color-gamut: rec2020)").matches;
            },

            () =>
            {
                const api_gamepad = !(!navigator.getGamepads);
                this._logResult.api_gamepad = api_gamepad;

                const gamepads = navigator.getGamepads ? navigator.getGamepads() : (navigator.webkitGetGamepads ? navigator.webkitGetGamepads : []);
            },

            () =>
            {
                const api_bluetooth = !!navigator.bluetooth || false;
            },

            async () =>
            {
                let xr = navigator.xr;
                if (!xr) return;

                this._logResult.api_webxr = !!xr;
                this._logResult.api_webxrvr = await xr.isSessionSupported("immersive-vr");
                this._logResult.api_webxrar = await xr.isSessionSupported("immersive-ar");
            },

            () =>
            {
                let prefix = "";
                if (window.RTCPeerConnection)
                {
                    prefix = "";
                }
                else if (window.mozRTCPeerConnection || navigator.mozGetUserMedia)
                {
                    prefix = "moz";
                }
                else if (window.webkitRTCPeerConnection || navigator.webkitGetUserMedia)
                {
                    prefix = "webkit";
                }

                const peerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
                const getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia;
                const mediaStream = window.webkitMediaStream || window.MediaStream;
                const ice = window.mozRTCIceCandidate || window.RTCIceCandidate;

                this._logResult.api_webrtc_support = !!peerConnection && !!getUserMedia;
                this._logResult.api_webrtc_prefix = prefix;
                this._logResult.api_webrtc_peer_connection = !!peerConnection;
                this._logResult.api_webrtc_ice = !!ice;
                this._logResult.api_webrtc_media_stream = !!(mediaStream && mediaStream.prototype.removeTrack);
                this._logResult.api_webrtc_get_user_media = !!getUserMedia;
                this._logResult.api_webrtc_data_channel = !!(peerConnection && peerConnection.prototype && peerConnection.prototype.createDataChannel);
            },

            () =>
            {
                if (navigator.getVRDisplays)
                {
                    navigator.getVRDisplays().then((displays) =>
                    {
                        for (let displs = 0; displs < displays.length; displs++)
                            this._logResult.api_webvr_display = displays[displs].displayName;

                        const api_webvr = !(!navigator.getVRDisplays);
                        this._logResult.api_webvr = api_webvr;
                    });
                }
            },

            () =>
            {
                const api_midi = !(!window.MIDIAccess);
                this._logResult.api_midi = api_midi;
            },

            () =>
            {
                let api_webaudio = false;
                if (window.audioContext) api_webaudio = true;
                if (!api_webaudio && ("webkitAudioContext" in window || "AudioContext" in window)) api_webaudio = true;
                this._logResult.api_webaudio = api_webaudio;

                if (api_webaudio)
                {
                    const audioContext = new AudioContext();
                    if (audioContext)
                    {
                        if ("baseLatency" in audioContext) this._logResult.web_audio_base_latency = audioContext.baseLatency;
                        if ("outputLatency" in audioContext) this._logResult.web_audio_output_latency = audioContext.outputLatency;
                        if ("sampleRate" in audioContext) this._logResult.web_audio_sample_rate = audioContext.sampleRate;
                        if (audioContext.destination)
                        {
                            if ("channelCount" in audioContext.destination) this._logResult.web_audio_channel_count = audioContext.destination.channelCount;
                            if ("channelCountMode" in audioContext.destination) this._logResult.web_audio_channel_count_mode = audioContext.destination.channelCountMode;
                            if ("channelInterpretation" in audioContext.destination) this._logResult.web_audio_channel_interpretation = audioContext.destination.channelInterpretation;
                            if ("maxChannelCount" in audioContext.destination) this._logResult.web_audio_max_channel_count = audioContext.destination.maxChannelCount;
                            if ("numberOfInputs" in audioContext.destination) this._logResult.web_audio_number_of_inputs = audioContext.destination.numberOfInputs;
                            if ("numberOfOutputs" in audioContext.destination) this._logResult.web_audio_number_of_outputs = audioContext.destination.numberOfOutputs;
                        }
                    }
                }
            },

            () =>
            {
                const api_fonts = ("fonts" in document);
                this._logResult.api_fonts = api_fonts;
            },

            () =>
            {
                const api_pointerlock = ("exitPointerLock" in document);
                this._logResult.api_pointerlock = api_pointerlock;
            },

            () =>
            {
                const api_performanceTimer = ("performance" in window);
                this._logResult.api_performanceTimer = api_performanceTimer;
            },

            () =>
            {
                const canSvg = !!(document.createElementNS && document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
                this._logResult.api_svg = canSvg;
            },

            () =>
            {
                const api_websocket = ("WebSocket" in window);
                this._logResult.api_websocket = api_websocket;
            },

            () =>
            {
                const api_bluetooth = ("bluetooth" in navigator);
                this._logResult.api_bluetooth = api_bluetooth;
            },

            () =>
            {
                const api_broadcastchannel = ("BroadcastChannel" in window);
                this._logResult.api_broadcastchannel = api_broadcastchannel;
            },

            () =>
            {
                const api_notifications = ("Notification" in window);
                this._logResult.api_notifications = api_notifications;
            },

            () =>
            {
                const api_fileSystemAccessApi = ("showOpenFilePicker" in window);
                this._logResult.api_fileSystemAccessApi = api_fileSystemAccessApi;
            },

            () =>
            {
                const api_webshare = ("share" in navigator);
                this._logResult.api_webshare = api_webshare;
            }
        ];
    }

    getGPU(renderer)
    {
        const info = {};

        let gpu = renderer;

        gpu = gpu.replace("Mesa DRI ", "");
        gpu = gpu.replace("Mesa ", "");
        gpu = gpu.replace("NVIDIA Corporation, ", "");
        gpu = gpu.replace("Intel Open Source Technology Center, ", "");
        gpu = gpu.replace("(R)", "");
        gpu = gpu.replace("(TM)", "");
        gpu = gpu.replace("Direct3D11 vs_5_0 ps_5_0)", "");
        gpu = gpu.replace("Direct3D11 vs_4_1 ps_4_1)", "");
        gpu = gpu.replace("OpenGL Engine", "");
        gpu = gpu.replace("/PCIe/SSE2", "");
        gpu = gpu.replace("X.Org, ", "");
        gpu = gpu.replace("ATI Radeon", "Radeon");
        gpu = gpu.replace("with Max-Q Design", "");
        gpu = gpu.replace("Series", "");
        gpu = gpu.replace("  ", " ");

        let parts = gpu.split(/[,(/)]/);
        let found = null;

        for (let j = 0; j < parts.length; j++)
        {
            let p = parts[j].trim();

            if (p.indexOf("Radeon") == 0)found = p;
            else if (p.indexOf("NVIDIA") == 0)found = p;
            else if (p.indexOf("AMD") == 0)found = p;
            else if (p.indexOf("GeForce") == 0)found = p;
            else if (p.indexOf("Intel") == 0)found = p;
            else if (p.indexOf("Mali") == 0)found = p;
            else if (p.indexOf("Adreno") == 0)found = p;
            else if (p.indexOf("PowerVR") == 0)found = p;
            else if (p.indexOf("VMware") == 0)found = p;
            else if (p.indexOf("Apple") == 0)found = p;
        }

        if (found && found.indexOf("Radeon") == 0)found = "AMD " + found;
        if (found && found.indexOf("GeForce") == 0)found = "NVIDIA " + found;

        if (!found)
        {
            info.gpu_unsure = true;
            console.log("unsure of gpu:", renderer);
        }
        info.gpu = (found || renderer).trim();

        let vendor = "";
        if (renderer.toLowerCase().indexOf("nvidia") > -1)vendor = "Nvidia";
        if (renderer.toLowerCase().indexOf("geforce") > -1)vendor = "Nvidia";
        if (renderer.toLowerCase().indexOf("radeon") > -1)vendor = "AMD";
        if (renderer.toLowerCase().indexOf("amd ") > -1)vendor = "AMD";
        if (renderer.toLowerCase().indexOf("intel") > -1)vendor = "Intel";
        if (renderer.toLowerCase().indexOf("swiftshader") > -1)vendor = "Google";
        if (renderer.toLowerCase().indexOf("adreno") > -1)vendor = "Qualcom";
        if (renderer.toLowerCase().indexOf("mali-") > -1)vendor = "ARM";
        if (renderer.toLowerCase().indexOf("apple") > -1)vendor = "Apple";

        info.vendor = vendor;

        if (renderer.toLowerCase().indexOf("swiftshader") > -1)
        {
            info.software = true;
        }

        return info;
    }

    async doBrowserTest(cb)
    {
        for (const i in this._tests)
        {
            // eslint-disable-next-line no-await-in-loop
            await this._tests[i]();
        }

        web.cookies.createCookie("browserinfo", true, 100);
        api.post("browser", { "browser": this._logResult }, (r) =>
        {
            const loadingEle = ele.byId("browserLoading");
            if (loadingEle) ele.hide(loadingEle);

            const resultIframe = document.getElementById("resultIframe");
            if (resultIframe) resultIframe.src = "/browser/r/" + r.id + "?embed=true";

            const head = document.getElementsByTagName("head");
            if (head && head.length > 0)
            {
                const baseTag = document.createElement("base");
                baseTag.setAttribute("target", "_parent");
                head[0].appendChild(baseTag);
            }

            const footer = document.getElementsByTagName("footer");
            if (footer && footer.length > 0) footer[0].remove();

            if (cb) cb(r);
        });
    }

    doBrowserSpeedTest(button)
    {
        function randomData(size)
        {
            let chars = "abcdefghijklmnopqrstuvwxyz".split("");
            let len = chars.length;
            let random_data = [];

            while (size--)
            {
                random_data.push(chars[Math.random() * len | 0]);
            }

            return random_data.join("");
        }

        function showSpeedTestResult(className, numBytes, speedTest, hideLoading)
        {
            const dir = speedTest.dir;
            const containerEle = document.getElementById("speedtestResult");
            const resultEle = containerEle.querySelector(".results");
            if (speedTest.result.clientDiff)
            {
                const clientEl = resultEle.querySelector("." + className + " .client .time");
                clientEl.innerText = parseInt(speedTest.result.clientDiff) + "ms";
                const diffEl = resultEle.querySelector("." + className + " .client .speed");
                diffEl.innerText = parseInt(Number(speedTest.result.clientDiff - speedTest.result.diff)) + "ms";

                const speed = ((numBytes * 8) / 1024 / 1024) / (speedTest.result.clientDiff / 1000);
                diffEl.innerText = speed.toFixed(2) + " mbit/s";
            }
            if (speedTest.result.hasOwnProperty("processingTime"))
            {
                const serverEl = resultEle.querySelector("." + className + " .servertime");
                serverEl.innerText = parseInt(speedTest.result.processingTime) + "ms";
            }
            if (dir)
            {
                if (hideLoading)
                {
                    const dirLoader = ele.byQuery("." + dir + " .loading");
                    if (dirLoader) ele.hide(dirLoader);
                }
                const dirResultsEl = ele.byQueryAll("." + dir + " .result");
                dirResultsEl.forEach((el) => { ele.show(el); });
            }
        }

        function showSpeedTestError(e)
        {
            web.buttons.stopSavingAnimButton();
            const containerEle = document.getElementById("speedtestResult");
            const el = containerEle.querySelector(".error");
            if (el)
            {
                el.classList.remove("hidden");
                const msgEl = el.querySelector(".message");
                if (msgEl) msgEl.innerText = "error during speedtest:" + e;
            }
        }

        web.buttons.startSavingAnimButton(button);
        const all = {};

        const dirResultsEl = ele.byQueryAll(".results .result");
        dirResultsEl.forEach((el) => { ele.hide(el); });
        const dirLoaders = ele.byQueryAll(".results .loading");
        dirLoaders.forEach((el) => { ele.show(el); });

        const containerEle = document.getElementById("speedtestResult");
        const resultEle = containerEle.querySelector(".results");
        resultEle.classList.remove("hidden");

        const startDirectSmall = performance.now();
        const cb = Date.now();
        fetch("/test_files/onemb.txt?cb=" + cb).then((resp) => { return resp.text(); }).then(() =>
        {
            let endDirectSmall = performance.now();
            let data = {};
            data.clientStart = startDirectSmall;
            data.clientEnd = endDirectSmall;
            data.clientDiff = endDirectSmall - startDirectSmall;
            all.fetchDirectSmall = {
                "dir": "downdirect",
                "size": "small",
                "result": data
            };
            showSpeedTestResult("downdirectsmall", 1048576, all.fetchDirectSmall);
            const startSmall = performance.now();
            api.get("browser/download/small?cb=" + cb, (fsres) =>
            {
                const endSmall = performance.now();
                data = {};
                if (fsres.data) data = fsres.data;
                if (fsres.data.data) delete fsres.data.data;
                data.clientStart = startSmall;
                data.clientEnd = endSmall;
                data.clientDiff = endSmall - startSmall;
                all.fetchSmall = {
                    "dir": "down",
                    "size": "small",
                    "result": data
                };
                showSpeedTestResult("downsmall", 1048576, all.fetchSmall);
                const startDirectBig = performance.now();
                fetch("/test_files/tenmb.txt?cb=" + cb).then((resp) => { return resp.text(); }).then(() =>
                {
                    const endDirectBig = performance.now();
                    data = {};
                    data.clientStart = startDirectBig;
                    data.clientEnd = endDirectBig;
                    data.clientDiff = endDirectBig - startDirectBig;
                    all.fetchDirectBig = {
                        "dir": "downdirect",
                        "size": "big",
                        "result": data
                    };
                    showSpeedTestResult("downdirectbig", 10485760, all.fetchDirectBig, true);
                    const startBig = performance.now();
                    api.get("browser/download/big?cb=" + cb, (fbres) =>
                    {
                        const endBig = performance.now();
                        data = {};
                        if (fbres.data) data = fbres.data;
                        if (fbres.data.data) delete fbres.data.data;
                        data.clientStart = startBig;
                        data.clientEnd = endBig;
                        data.clientDiff = endBig - startBig;
                        all.fetchBig = {
                            "dir": "down",
                            "size": "big",
                            "result": data
                        };
                        showSpeedTestResult("downbig", 10485760, all.fetchBig, true);
                        let content = { "data": randomData(1048576) };
                        const startUpSmall = performance.now();
                        api.post("browser/upload/small", content, (usres) =>
                        {
                            const endUpSmall = performance.now();
                            data = {};
                            if (usres.data) data = usres.data;
                            if (usres.data.data) delete usres.data.data;
                            data.clientStart = startUpSmall;
                            data.clientEnd = endUpSmall;
                            data.clientDiff = endUpSmall - startUpSmall;
                            all.upSmall = {
                                "dir": "up",
                                "size": "small",
                                "result": data
                            };
                            showSpeedTestResult("upsmall", 1048576, all.upSmall);
                            content = { "data": randomData(10485760) };
                            const startUpBig = performance.now();
                            api.post("browser/upload/big", content, (ubres) =>
                            {
                                const endUpBig = performance.now();
                                data = {};
                                if (ubres.data) data = ubres.data;
                                if (ubres.data.data) delete ubres.data.data;
                                data.clientStart = startUpBig;
                                data.clientEnd = endUpBig;
                                data.clientDiff = endUpBig - startUpBig;
                                all.upBig = {
                                    "dir": "up",
                                    "size": "big",
                                    "result": data
                                };
                                showSpeedTestResult("upbig", 10485760, all.upBig, true);
                                web.buttons.stopSavingAnimButton();
                                api.post("browser/speedtest", all);
                            }, showSpeedTestError);
                        }, showSpeedTestError);
                    }, showSpeedTestError);
                }, showSpeedTestError);
            }, showSpeedTestError);
        }, showSpeedTestError);
    }
}
